/* -------------------------------------------------------------------------- */
/*                                Configuration                                 */
/* -------------------------------------------------------------------------- */

/**
Table schema configuration for the module
@type {TableSchemaBase}
*/
import ScopeFilterOperators from 'ui/components/DataGrid/Filters/ScopeFilter/ScopeFilter';
import DateFilterOperators from 'ui/components/DataGrid/Filters/DateFilter/DateFilter';

const tableSchemaBase = [
  { field: 'user', flex: 1, resizable: true, headerName: 'name', fontSize: '2px', type: 'user', minWidth: 250 },
  {
    field: 'scopeName',
    headerName: 'scope',
    type: 'text',
    minWidth: 250,
    filterOperators: ScopeFilterOperators,
    resizable: true,
    flex: 1,
  },
  {
    field: 'createdAt',
    headerName: 'registration_date',
    filterOperators: DateFilterOperators,
    type: 'text',
    minWidth: 180,
    resizable: true,
    flex: 1,
  },
  {
    field: 'programmesStarted',
    headerName: 'programmes_started',
    type: 'text',
    minWidth: 150,
    resizable: true,
    flex: 1,
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
    align: 'center',
  },
  {
    field: 'countProgramLast6Months',
    headerName: 'count_program_last_6_months',
    type: 'text',
    minWidth: 200,
    resizable: true,
    flex: 1,
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
    align: 'center',
  },
  {
    field: 'lastLogin',
    headerName: 'last_login',
    type: 'text',
    minWidth: 185,
    align: 'center',
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
  },
  {
    field: 'adminNote',
    headerName: 'admin_note_header',
    type: 'adminNote',
    minWidth: 185,
    flex: 1,
    align: 'center',
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
  },
  {
    field: 'actions',
    headerName: 'actions',
    sortable: false,
    minWidth: 120,
    filter: false,
    filterable: false,
    valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    type: 'actionsAdmins',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    resizable: true,
    disableColumnMenu: true,
  },
];

const sampleDataBase = [...Array(10).keys()].map((i) => ({
  id: i + 1,
  userScope: null,
  user: {
    name: 'rami',
    title: 'Coaching professionnel - Experienced Management Consultant & Executive Coach',
    picture:
      'https://pathline-dev-bucket.s3.fr-par.scw.cloud/profile-pictures/a19c78e0-6695-11ed-b755-138e5076a13d.png',
  },
  registrationDate: '12 month ago',
  type: 'true',
  email: 'laurent_coach_dev@yopmail.com',
}));

export { tableSchemaBase, sampleDataBase };
